import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/logo2.png'


const _hoisted_1 = {
  class: "navbar is-fixed-top",
  role: "navigation",
  "aria-label": "main navigation"
}
const _hoisted_2 = { class: "navbar-brand" }
const _hoisted_3 = { class: "navbar-end" }
const _hoisted_4 = { class: "navbar-item" }
const _hoisted_5 = { class: "navbar-item" }
const _hoisted_6 = { class: "navbar-item" }
const _hoisted_7 = { class: "navbar-item" }
const _hoisted_8 = { class: "navbar-item" }
const _hoisted_9 = { class: "navbar-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBarBrandIcon = _resolveComponent("NavBarBrandIcon")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("a", {
        class: "navbar-item logo",
        href: "http://geoffrey.lalloue.fr"
      }, [
        _createElementVNode("img", {
          src: _imports_0,
          width: "200",
          height: "60",
          alt: "Geoffrey Lalloue personnal website icon"
        })
      ], -1)),
      _createElementVNode("a", {
        role: "button",
        class: _normalizeClass(["navbar-burger", { 'is-active' : $data.showNav }]),
        "aria-label": "menu",
        "aria-expanded": "false",
        "data-target": "links",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($data.showNav = !$data.showNav))
      }, [...(_cache[1] || (_cache[1] = [
        _createElementVNode("span", { "aria-hidden": "true" }, null, -1),
        _createElementVNode("span", { "aria-hidden": "true" }, null, -1),
        _createElementVNode("span", { "aria-hidden": "true" }, null, -1)
      ]))], 2)
    ]),
    _createElementVNode("div", {
      id: "links",
      class: _normalizeClass(["navbar-menu", { 'is-active' : $data.showNav }])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_NavBarBrandIcon, {
            icon: "x-twitter",
            url: "https://x.com/glalloue",
            color: "is-twitter"
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_NavBarBrandIcon, {
            icon: "medium-m",
            url: "https://medium.com/@glalloue",
            color: "is-medium-com"
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_NavBarBrandIcon, {
            icon: "facebook",
            url: "https://www.facebook.com/geoffrey.lalloue/",
            color: "is-facebook"
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_NavBarBrandIcon, {
            icon: "strava",
            url: "https://www.strava.com/athletes/geoffrey_lalloue",
            color: "is-strava"
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_NavBarBrandIcon, {
            icon: "linkedin",
            url: "https://www.linkedin.com/in/geoffreylalloue/",
            color: "is-linkedin"
          })
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_NavBarBrandIcon, {
            icon: "github",
            url: "https://github.com/glalloue",
            color: "is-github"
          })
        ])
      ])
    ], 2)
  ]))
}